export enum FocusModePage {
  Main = 'Main',
  SessionDone = 'SessionDone',
  TaskSelection = 'TaskSelection',
  DurationSelection = 'DurationSelection',
  Preparation = 'Preparation',
  Break = 'Break',
  ProcrastinationHelp = 'ProcrastinationHelp',
}
